import { render, staticRenderFns } from "./PremiumClaim.vue?vue&type=template&id=d9ece250"
import script from "./PremiumClaim.vue?vue&type=script&lang=js"
export * from "./PremiumClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports